"use client";

import React, { useEffect } from "react";
import NoInternetPage from "src/components/Common/NoInternet";

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    console.error("Unhandled error captured by boundary:", error);
  }, [error]);

  const isNetworkError = typeof window !== "undefined" && !window.navigator.onLine;

  const handleRetry = async () => {
    if (typeof window === "undefined") return;

    if (!window.navigator.onLine) {
      alert("You are still offline. Please check your internet connection.");
      return;
    }

    try {
      const response = await fetch("/favicon.ico", {
        method: "HEAD",
        cache: "no-store",
      });
      if (response.ok) {
        window.location.reload();
      } else {
        reset();
      }
    } catch (e) {
      reset();
    }
  };

  if (isNetworkError) {
    return <NoInternetPage onRetry={handleRetry} />;
  }

  return (
    <div className="relative min-h-screen overflow-hidden bg-black text-white flex items-center justify-center px-6!">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-purple-900/20 blur-3xl rounded-full animate-pulse" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-950/20 blur-3xl rounded-full animate-pulse delay-300" />
      </div>

      <div className="relative z-10 max-w-xl text-center">
        <h1 className="text-4xl md:text-5xl font-black mb-6!">
          Something Went <span className="text-purple-500">Wrong</span>
        </h1>
        <p className="text-gray-400 text-lg leading-relaxed mb-8!">An unexpected error occurred while loading this page. Let's try reloading to fix it.</p>
        <button
          onClick={() => reset()}
          className="px-8! py-4! rounded-2xl bg-purple-600 hover:bg-purple-700 transition-all duration-300 font-semibold shadow-[0_0_30px_rgba(147,51,234,0.4)] hover:scale-105 cursor-pointer"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
